import { useTheme } from "@/context/ThemeContext";

const services = [
  {
    icon: "ri-robot-line",
    title: "AI Voice & Chat Automation",
    desc: "24/7 intelligent call handling and chat responses that never miss a lead.",
    img: "https://public.readdy.ai/ai/img_res/fbb4834299e96ccacbac2e672bf4f50e.jpg",
  },
  {
    icon: "ri-filter-line",
    title: "Lead Capture & Routing",
    desc: "Automatically capture, qualify, and route every inbound lead to the right pipeline.",
    img: "https://readdy.ai/api/search-image?query=digital%20funnel%20data%20flow%20visualization%20abstract%20network%20nodes%20connections%20minimal%20dark%20background%20technology%20business%20analytics%20premium%20clean&width=600&height=400&seq=svc-lead-002&orientation=landscape",
  },
  {
    icon: "ri-send-plane-line",
    title: "Instant Follow-Up Systems",
    desc: "Automated multi-channel follow-up sequences triggered the moment a lead comes in.",
    img: "https://readdy.ai/api/search-image?query=instant%20messaging%20notification%20system%20abstract%20digital%20communication%20network%20glowing%20lines%20dark%20background%20minimal%20technology%20premium&width=600&height=400&seq=svc-followup-003&orientation=landscape",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Booking & Scheduling Automation",
    desc: "Seamless appointment booking without any manual coordination.",
    img: "https://readdy.ai/api/search-image?query=digital%20calendar%20scheduling%20interface%20clean%20minimal%20abstract%20technology%20appointment%20booking%20system%20dark%20background%20premium%20modern&width=600&height=400&seq=svc-booking-004&orientation=landscape",
  },
  {
    icon: "ri-bar-chart-box-line",
    title: "CRM & Pipeline Setup",
    desc: "Fully configured CRM with automated pipeline stages and deal tracking.",
    img: "https://readdy.ai/api/search-image?query=CRM%20pipeline%20dashboard%20data%20visualization%20abstract%20business%20analytics%20charts%20minimal%20dark%20background%20technology%20premium%20clean%20modern&width=600&height=400&seq=svc-crm-005&orientation=landscape",
  },
  {
    icon: "ri-line-chart-line",
    title: "Reporting & Performance Tracking",
    desc: "Real-time dashboards showing exactly where leads come from and convert.",
    img: "https://readdy.ai/api/search-image?query=performance%20analytics%20dashboard%20real%20time%20data%20charts%20graphs%20minimal%20clean%20dark%20background%20business%20intelligence%20premium%20technology%20modern&width=600&height=400&seq=svc-report-006&orientation=landscape",
  },
];

export default function ServicesSection() {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  return (
    <section className={`py-32 md:py-44 transition-colors duration-300 ${isDark ? "bg-[#111111]" : "bg-[#f5f5f7]"}`}>
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="mb-20 max-w-2xl">
          <p className={`text-[11px] tracking-[0.15em] uppercase font-semibold mb-5 ${isDark ? "text-white/35" : "text-[#6e6e73]"}`}>What We Do</p>
          <h2 className={`text-4xl md:text-5xl lg:text-6xl font-black leading-[1.05] tracking-[-0.02em] ${isDark ? "text-white" : "text-[#1d1d1f]"}`}>
            We don&apos;t sell tools.
            <br />
            <span className={isDark ? "text-white/35" : "text-[#6e6e73]"}>We build complete business systems.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {services.map((service) => (
            <div
              key={service.title}
              className={`rounded-2xl overflow-hidden group transition-all duration-300 hover:-translate-y-1 ${
                isDark ? "bg-[#1c1c1e] border border-white/6" : "bg-white border border-black/5"
              }`}
            >
              {/* Image */}
              <div className="w-full h-44 overflow-hidden">
                <img
                  src={service.img}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              {/* Content */}
              <div className="p-6">
                <div className={`w-9 h-9 flex items-center justify-center rounded-xl mb-4 ${isDark ? "bg-white/8" : "bg-[#f5f5f7]"}`}>
                  <i className={`${service.icon} text-lg ${isDark ? "text-white/75" : "text-[#1d1d1f]/75"}`}></i>
                </div>
                <h3 className={`font-bold text-base mb-2 ${isDark ? "text-white" : "text-[#1d1d1f]"}`}>{service.title}</h3>
                <p className={`text-sm leading-relaxed ${isDark ? "text-white/40" : "text-[#6e6e73]"}`}>{service.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className={`text-lg font-light ${isDark ? "text-white/40" : "text-[#6e6e73]"}`}>
            Everything works together.{" "}
            <span className={`font-semibold ${isDark ? "text-white" : "text-[#1d1d1f]"}`}>Nothing falls through the cracks.</span>
          </p>
        </div>
      </div>
    </section>
  );
}
